import React, { forwardRef } from "react";

import { StyledContentSection, StyledSection } from "./styles";
import { SectionProps } from "./types";

/**
 * Componente Section
 *
 * Um contêiner flexível para organizar conteúdos dentro de uma seção estilizada.
 *
 * @param {string} backgroundColor - Cor de fundo da seção (aceita valores do tema ou customizados).
 * @param {number} maxWidth - Largura máxima do conteúdo interno da seção (em pixels).
 * @param {React.ReactNode} children - Conteúdo exibido dentro da seção.
 * @param {string} [sectionId] - ID personalizado para a seção.
 * @param {boolean} [isVisible=true] - Define se a seção será exibida ou não.
 */
export const Section = forwardRef<HTMLDivElement, SectionProps>(
  (
    { backgroundColor, maxWidth, children, sectionId, isVisible = true },
    ref,
  ) => {
    const ID =
      sectionId || `section-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <StyledSection
        ref={ref}
        id={ID}
        backgroundColor={backgroundColor}
        isVisible={isVisible}
      >
        <StyledContentSection maxWidth={maxWidth}>
          {children}
        </StyledContentSection>
      </StyledSection>
    );
  },
);

Section.displayName = "Section";
